import React, { useState } from "react";
import { Link } from "gatsby";
import LogoMaroon from "../images/UChicago-logo-maroon.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/navBarMobile-styles.css";
import { useLocation } from "@reach/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faClose,
  faChevronDown,
  faChevronUp,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LogoBlock from "../images/summer-at-block.svg";

const NavBarMobile = ({ menuItems, courseGroup }) => {
  //console.log(courseGroup)
  const [hoveredNav] = useState(null);
  const [hoveredSubNavItem, setHoveredSubNavItem] = useState(null);
  // State to manage if the menu is shown or not
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubMenuName, setOpenSubMenuName] = useState(null);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  // Function to toggle the menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleSubMenu = (name) => {
    setOpenSubMenuName((currentName) => (currentName === name ? null : name));
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const location = useLocation(); // Get current URL path
  const currentPath = location.pathname; // Extract the path

  // Determine which navGroupName to filter based on the current path
  const navGroupToDisplay =
    currentPath.includes("/pre-college") || courseGroup === "Pre-College"
      ? "Pre-College"
      : currentPath.includes("/undergraduates") ||
        courseGroup === "Undergraduate"
      ? "Undergraduates"
      : courseGroup === "Both"
      ? "Both"
      : null;

      console.log(navGroupToDisplay)
  // Filter menu items based on the navGroupName
  const filteredMenuItems = menuItems.filter(
    (menuItem) => menuItem.navGroupName === navGroupToDisplay
  );

  return (
    <>
      <Container fluid className="mobile">
        <Container>
          <Row>
            <Col xs={6} sm={6} id="logo-mobile">
              <Link to="/">
                <img src={LogoBlock} alt="The University of Chicago Summer" />
              </Link>
            </Col>
            <Col xs={6} className="hamburger">
              <button
                onClick={toggleMenu}
                aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                tabIndex="0"
              >
                <FontAwesomeIcon icon={isMenuOpen ? faClose : faBars} />
              </button>
            </Col>
          </Row>
        </Container>

        {isMenuOpen && (
          <Container fluid>
            <Container>
              <nav>
                <Row>
                  <Col>
                    <ul id="both">
                      {/* Check if navGroupToDisplay is "Both" */}
                      {navGroupToDisplay === "Both" && (
                        <>
                          <li className="nav-item">
                            <Link
                              to={`/pre-college/pre-college-course-finder/`}
                            >
                              Pre-College Course Finder
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to={`/undergraduates/undergraduate-course-finder/`}
                            >
                              Undergraduate Course Finder
                            </Link>
                          </li>
                        </>
                      )}

                      {/* Continue with the default behavior */}
                      {filteredMenuItems[0]?.navNextLevel
                        .filter((item) => !item.excludeFromNavigation)
                        .map((item) => (
                          <li key={item.navSlug}>
                            <Link
                              href={`/${filteredMenuItems[0].navSlug}/${item.navSlug}`}
                            >
                              {`${item.displayItemName}`}
                            </Link>

                            {item.navNextLevel?.length > 0 && (
                              <button
                                onClick={() => toggleSubMenu(item.navNextLevel)}
                                aria-label={
                                  openSubMenuName === item.navNextLevel
                                    ? "Close submenu"
                                    : "Open submenu"
                                }
                                tabIndex={0}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    openSubMenuName === item.navNextLevel
                                      ? faChevronUp
                                      : faChevronDown
                                  }
                                />
                              </button>
                            )}

                            {openSubMenuName === item.navNextLevel && (
                              <SubNav
                                navNextLevel={item.navNextLevel}
                                basePath={`/${filteredMenuItems[0].navSlug}/${item.navSlug}`}
                                name={item.navNextLevel}
                              />
                            )}
                          </li>
                        ))}
                    </ul>
                  </Col>
                </Row>
              </nav>
            </Container>
          </Container>
        )}
      </Container>
    </>
  );
};

const SubNav = ({ navNextLevel, basePath, name }) => {
  if (!navNextLevel || navNextLevel.length === 0) {
    return null;
  }
  // console.log(navNextLevel[0].displayItemName)
  return (
    <>
      {/* <Container name={name}>
        <Row>
          <Col> */}
      <ul className="sub-nav-levels">
        {navNextLevel.map((subNav) => (
          <li key={subNav.displayItemName} className="first-level">
            <ul>
              <li>
                <Col>
                  <Link
                    to={`${basePath}/${subNav.navSlug}`}
                    className="first-level-link"
                  >
                    {subNav.displayItemName}
                  </Link>
                </Col>
              </li>
            </ul>
          </li>
        ))}
      </ul>
      {/* </Col>
        </Row>
      </Container> */}
    </>
  );
};

export default NavBarMobile;
